<div
  *ngIf="parentFormGroup.controls[controlName]"
  class="font-work-sans font-regular"
>
  <div
    class="form-field-label {{type}}"
    *ngIf="label"
  >
    {{label}}
    <span
      *ngIf="isRequired"
      class="required-mark"
    >*</span>
  </div>
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="outline"
    class="form-field w-full"
    [ngClass]="type ? 'small' : ''"
    hideRequiredMarker
  >
    <mat-icon
      *ngIf="prefixIcon"
      class="prefix"
      matPrefix
      svgIcon="{{prefixIcon}}"
    ></mat-icon>
    <mat-icon
      *ngIf="suffixIcon"
      class="suffix"
      matSuffix
      svgIcon="{{suffixIcon}}"
    ></mat-icon>
    <input
      #input
      class="input {{type}} number-input {{textAlign}}"
      [formControlName]="controlName"
      [max]="max"
      [maxlength]="maxLength"
      [min]="min"
      [decimal]="isDecimalAllowed"
      matInput
      placeholder="{{placeholder}}"
      type="text"
      onlyDigit
      (input)="onInputNumberFormat($event)"
      (blur)="onBlurNumberFormat($event)"
    >
    <mat-error *ngIf="error">{{error}}</mat-error>
    <span *ngIf="suffixText" matTextSuffix>{{ suffixText }}</span>
    <span *ngIf="prefixText" matTextPrefix>{{ prefixText }}</span>
  </mat-form-field>
</div>
